export default "__VITE_ASSET__ac881811__"